import React, { useState } from 'react'
import hero from "../../assets/videos/Unleash_Banner.mp4"
import './main.scss'

// const heroBannerVidUrl = 'https://strunleashprd.blob.core.windows.net/cms/unleash-landing/hero_banner.mp4?sp=r&st=2025-08-21T14:51:40Z&se=2028-12-31T23:06:40Z&spr=https&sv=2024-11-04&sr=b&sig=ELKAJRwICyiORp26JMz5FIHw9UhhdZfI2fYgDzYqWX8%3D';
const heroBannerVidUrl = 'https://strunleashprd.blob.core.windows.net/cms/unleash-landing/Unleash_Banner.mp4?sp=r&st=2026-03-26T05:09:06Z&se=2030-01-01T13:24:06Z&spr=https&sv=2025-11-05&sr=b&sig=H%2BwPXnV%2F%2FzxEXSwdwoRqWIEu8FJvXacAlNiLWh7Oflc%3D';
const videoSrc = hero || heroBannerVidUrl;

export default function HeroSection() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <div className='hero'>
            <div className='hero-container'>
                {/* Clickable Background */}
                <div className="hero-background" onClick={openModal}>
                    <video src={videoSrc} className='hero' autoPlay loop muted />
                </div>
                <div className='hero-contents'>
                    <h1 className='hero-header'>Download Unleash Today!</h1>
                    <p className='hero-text'>Unlock endless fun for you and your pet with our all-in-one app! Shop for trendy pet gear, connect with other pet lovers, and join a lively pet community—all in one place!</p>
                    <div className="hero-btns" onClick={() => window.open("https://unleash.ph/download-link", "_blank")} > DOWNLOAD NOW </div>
                </div>

                {/* Popup Video */}
                {isModalOpen && (
                    <div className="video-modal" onClick={closeModal}>
                        <div className="video-wrapper">
                            <video src={hero} controls autoPlay />
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
